import { render, staticRenderFns } from "./EmailVerifiedNotice.vue?vue&type=template&id=125c8ec6"
import script from "./EmailVerifiedNotice.vue?vue&type=script&lang=js"
export * from "./EmailVerifiedNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports